// extracted by mini-css-extract-plugin
module.exports = {"figure":"FigureCaption_figure__NHNG5","half":"FigureCaption_half__157oC","caption":"FigureCaption_caption__bg50R","credits":"FigureCaption_credits__WoB7Y"};